//import { type } from 'jquery';
import * as gl from 'Utils/global';
import { PriceValueType, FilterPricingMode, ConceptCode } from 'KM/common-models';
import moment from 'moment';
import CryptoJS from 'crypto-js';
//import sjcl from 'sjcl';


let ItemCategoryType = {

    // AnalyticsBookingItem
    Hotel: "HOTEL",
    Flight: "FLIGHT",
    Car: "CAR",
    Transfer: "TRANSFER",
    CancellationProtection: "CXL",

    //Hideaways analytics implementation
    HotelOnly: "HOTEL ONLY",
    HotelWithFlight: "HOTEL+FLIGHT"

};

// ***********************************************
function getPageItemListId() {
    if (!AppData.GoogleAnalytics) return undefined;
    if (!AppData.GoogleAnalytics.Tracking) return undefined;
    if (!AppData.GoogleAnalytics.Tracking.item_list_id) return undefined;
    return AppData.GoogleAnalytics.Tracking.item_list_id;
};
function getPageItemListName() {
    if (!AppData.GoogleAnalytics) return undefined;
    if (!AppData.GoogleAnalytics.Tracking) return undefined;
    if (!AppData.GoogleAnalytics.Tracking.item_list_name) return undefined;
    return AppData.GoogleAnalytics.Tracking.item_list_name;
};

function getItemlistFromQueryString() {
    let item_list_id = gl.getParameterByName('dl_ili');
    let item_list_name = gl.getParameterByName('dl_iln');
    
    return {
        item_list_id: item_list_id,
        item_list_name: item_list_name,
    };
};

function getItemList() {
    let item_list_id = gl.getCookieItemListId();
    let item_list_name = gl.getCookieItemListName();

    if (!item_list_id || item_list_id == '') {
        item_list_id = getPageItemListId();
    }

    if (!item_list_name || item_list_name == '') {
        item_list_name = getPageItemListName();
    }

    let itemList = getItemlistFromQueryString();
    if (itemList) {
        if (itemList.item_list_id && itemList.item_list_id != '') {
            item_list_id = itemList.item_list_id;
        }

        if (itemList.item_list_name && itemList.item_list_name != '') {
            item_list_name = itemList.item_list_name;
        }
    }

    return {
        item_list_id: item_list_id,
        item_list_name: item_list_name,
    };
};
function setItemList(obj) {
    let item_list_id = undefined;
    let item_list_name = undefined;

    if (obj) {
        item_list_id = obj.item_list_id;
        item_list_name = obj.item_list_name;
    }

    gl.setCookieItemListId(item_list_id);
    gl.setCookieItemListName(item_list_name);
};

function updateItemListFromAppData() {
    setItemList({
        item_list_id: getPageItemListId(),
        item_list_name: getPageItemListName(),
    });
};
// ***********************************************

function hash(string) {
    if (!string || string == '') return '';
    /*
    // Ups this return Promise. The KO is not ready to use Promise's (or async/await) chains
    const utf8 = new TextEncoder().encode(string);
    return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray
            .map((bytes) => bytes.toString(16).padStart(2, '0'))
            .join('');
        return hashHex;
    });
    */

    // Compute the SHA-256 hash of a string
    let hashValue = CryptoJS.SHA256(string);
    // Get the hexadecimal hash value
    let hashHex = hashValue.toString(CryptoJS.enc.Hex);


    //// Compute the SHA-256 hash of a string
    //let hashValue1 = sjcl.hash.sha256.hash(string);
    //// Get the hexadecimal hash value
    //let hashHex1 = sjcl.codec.hex.fromBits(hashValue1);

    //console.log('>>> hash result:', {
    //    text: string,
    //    hash_CryptoJS: hashHex,
    //    hash_sjcl: hashHex1
    //});


    return hashHex;
};

function checkDataLayer() {
    if (!global.dataLayer) {
        global.dataLayer = [];
    }
};

function getPriceModel(hotel, isDirectFlight) {
    let priceTotal = ko.unwrap(hotel.PriceTotal);
    let price = priceTotal ? ko.unwrap(priceTotal.Value) : 0;
    let currency = priceTotal ? ko.unwrap(priceTotal.Currency) : '';

    if (isDirectFlight && typeof hotel.PriceTotalByType == 'function') {
        priceTotal = hotel.PriceTotalByType(PriceValueType.withDirectFlight);
        if (priceTotal) {
            price = ko.unwrap(priceTotal.Value);
        } else {
            price = 0;
        }
    }
    
    if ((!currency || currency == '') && AppData.Currency) {
        currency = AppData.Currency.Code
    }

    return {
        value: price,
        currency: currency
    };
};

function createHotelItem(hotel, itemList) {
    let concept = ko.unwrap(hotel.Concept);
    let conceptName = (concept && ConceptCode.Hideaways == ko.unwrap(concept.Code)) ? ko.unwrap(concept.Name) : '';

    let price = getPriceModel(hotel, ko.unwrap(itemList.IsDirectFlight)).value;

    let hotelOnly = ko.unwrap(itemList.HotelOnly);
    let category = ItemCategoryType.Hotel;
    if (!hotelOnly) {
        category = ItemCategoryType.HotelWithFlight;
    }

    let txtArrivalDate = '';
    let arrivalDate = ko.unwrap(hotel.ArrivalDate);
    if (arrivalDate) {
        txtArrivalDate = moment(arrivalDate).format("MMMM YYYY");
    }
    
    let destinationName = ko.unwrap(itemList.DestinationName);
    if (!destinationName || destinationName == '') {
        destinationName = ko.unwrap(hotel.DestinationName);
    }

    let item = {
        item_id: ko.unwrap(hotel.Id),
        item_name: ko.unwrap(hotel.Name),
        //affiliation: "Google Merchandise Store",
        //coupon: "SUMMER_FUN",
        //discount: 2.22,
        //index: 0,
        item_brand: conceptName,
        item_category: category, //same as purchase
        item_category2: ko.unwrap(itemList.DepartureAirportCode),
        item_category3: txtArrivalDate,
        item_category4: destinationName,
        item_category5: ko.unwrap(itemList.TotalPersons),
        item_list_id: ko.unwrap(itemList.id),
        item_list_name: ko.unwrap(itemList.name),
        //item_variant: "green",
        //location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
        price: price,
        quantity: 1
    };
    return item;
};

function createProductItem(product, itemList) {
    let id = ko.unwrap(product.Id);
    let code = ko.unwrap(product.Code);
    if (typeof id == "undefined" && typeof code != "undefined") {
        id = code;
    }
    let price = ko.unwrap(product.PriceTotal).Value;
    let item = {
        item_id: id,
        item_name: ko.unwrap(product.Name),
        //affiliation: "Google Merchandise Store",
        //coupon: "SUMMER_FUN",
        //discount: 2.22,
        //index: 0,
        //item_brand: conceptName,
        item_category: ko.unwrap(product.Category), //same as purchase
        item_list_id: ko.unwrap(itemList.id),
        item_list_name: ko.unwrap(itemList.name),
        //item_variant: "green",
        //location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
        price: price,
        quantity: 1
    };
    return item;
};

function createProductItems(products, itemList) {
    let items = products.map(function (product, index) {
        let category = ko.unwrap(product.Category);
        let arr = [
            ItemCategoryType.Hotel,
            ItemCategoryType.HotelOnly,
            ItemCategoryType.HotelWithFlight
        ];
        let is_hotel = arr.includes(category);
        let item = is_hotel ? createHotelItem(product, itemList) : createProductItem(product, itemList);
        if (is_hotel) {
            item.index = index;
        }
        return item;
    });
    return items;
};

function trackViewItemList(hotelResults, itemList) {
    checkDataLayer();

    let items = hotelResults.map(function (hotel, index) {
        let item = createHotelItem(hotel, itemList);
        item.index = index;
        return item;
    });

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        event: "view_item_list",
        ecommerce: {
            item_list_id: ko.unwrap(itemList.id),
            item_list_name: ko.unwrap(itemList.name),
            items: items
        }
    });

};

function trackViewItem(hotelResult, itemList) {
    checkDataLayer();

    let item = createHotelItem(hotelResult, itemList);
    item.index = 0;
    //item.price = ko.unwrap(itemList.TotalPrice);

    let base_price = getPriceModel(hotelResult, ko.unwrap(itemList.IsDirectFlight));

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        event: "view_item",
        ecommerce: {
            currency: base_price.currency,
            value: base_price.value,
            items: [ item ]
        }
    });

};

function trackViewCart(products, itemList) {
    checkDataLayer();

    let items = createProductItems(products, itemList);

    let currency = AppData.Currency.Code;
    let totalPrice = ko.unwrap(itemList.TotalPrice);

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        event: "view_cart",
        ecommerce: {
            currency: currency,
            value: totalPrice,
            items: items
        }
    });

};

function trackAddToCart(products, itemList) {
    checkDataLayer();

    let items = createProductItems(products, itemList);

    let currency = AppData.Currency.Code;
    let totalPrice = ko.unwrap(itemList.TotalPrice);

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            currency: currency,
            value: totalPrice,
            //coupon: "SUMMER_FUN",
            items: items
        }
    });

};

function trackRemoveFromCart(products, itemList) {
    checkDataLayer();

    let items = createProductItems(products, itemList);

    let currency = AppData.Currency.Code;
    let totalPrice = ko.unwrap(itemList.TotalPrice);

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
            currency: currency,
            value: totalPrice,
            //coupon: "SUMMER_FUN",
            items: items
        }
    });

};

function trackBeginCheckout(products, itemList) {
    checkDataLayer();

    let items = createProductItems(products, itemList);

    let currency = AppData.Currency.Code;
    let totalPrice = ko.unwrap(itemList.TotalPrice);

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
            currency: currency,
            value: totalPrice,
            //coupon: "SUMMER_FUN",
            items: items
        }
    });

};

function trackAddShippingInfo(products, itemList) {
    checkDataLayer();

    let items = createProductItems(products, itemList);

    let currency = AppData.Currency.Code;
    let totalPrice = ko.unwrap(itemList.TotalPrice);
    let user_data = ko.unwrap(itemList.user_data);

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        event: "add_shipping_info",
        ecommerce: {
            currency: currency,
            value: totalPrice,
            //coupon: "SUMMER_FUN",
            //shipping_tier: "Ground",
            items: items,
        },
        user_data: user_data
    });

};

function trackAddPaymentInfo(products, itemList) {
    checkDataLayer();

    let items = createProductItems(products, itemList);

    let currency = AppData.Currency.Code;
    let totalPrice = ko.unwrap(itemList.TotalPrice);
    let user_data = ko.unwrap(itemList.user_data);

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        event: "add_payment_info",
        ecommerce: {
            currency: currency,
            value: totalPrice,
            //coupon: "SUMMER_FUN",
            payment_type: "Credit Card",
            items: items
        },
        user_data: user_data
    });

};


function trackNewsletterSignup() {
    checkDataLayer();

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        event: "newsletter_signup",
    });

};

export {
    ItemCategoryType,
    getItemList, setItemList, updateItemListFromAppData,
    hash,
    trackViewItemList, trackViewItem,
    trackViewCart, trackAddToCart, trackRemoveFromCart,
    trackBeginCheckout,
    trackAddShippingInfo,
    trackAddPaymentInfo,
    trackNewsletterSignup
}